import { useEffect, useRef, useState } from "react";
import Card from "./card";
import { Link } from "react-router-dom";
import config from "../config";

function extractCity(address) {
  if (!address) return "";
  const parts = address.split(",");
  if (parts.length < 2) return address.trim();
  return parts[parts.length - 1].trim().replace(/^\d{5}\s*/, "");
}

function Kebablist() {
  const [reviews, setReviews] = useState(null);
  const [cityFilter, setCityFilter] = useState("Alle");
  const [sortByRating, setSortByRating] = useState(false);
  const hasFetched = useRef(false);

  const getReviews = async () => {
    const response = await fetch(`${config.BaseUrl}/reviews`, { method: "GET" });
    if (!response.ok) alert("could not fetch from Server");
    const data = await response.json();
    setReviews(data.reviews);
  };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    getReviews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!reviews || !Array.isArray(reviews)) {
    return (
      <div className="reviews-outer">
        <p style={{ color: "var(--ink-mute)" }}>Lade Bewertungen…</p>
      </div>
    );
  }

  const cities = ["Alle", ...Array.from(new Set(reviews.map((r) => extractCity(r.address)).filter(Boolean)))];

  const filtered = cityFilter === "Alle"
    ? reviews
    : reviews.filter((r) => extractCity(r.address) === cityFilter);

  const displayed = sortByRating
    ? [...filtered].sort((a, b) => b.rating - a.rating)
    : filtered;

  return (
    <div className="reviews-outer">
      <div className="section-head">
        <h2>Bewertungen</h2>
        <span className="count">{displayed.length} Läden</span>
      </div>

      <div className="controls">
        <div className="chips">
          {cities.map((city) => (
            <button
              key={city}
              className={`chip${cityFilter === city ? " active" : ""}`}
              onClick={() => setCityFilter(city)}
            >
              {city}
            </button>
          ))}
        </div>
        <button
          className={`sort-btn${sortByRating ? " active" : ""}`}
          onClick={() => setSortByRating((s) => !s)}
        >
          ★ Beste zuerst
        </button>
      </div>

      <div className="reviews-grid">
        {displayed.map((r) => (
          <Link
            key={r._id}
            to={`/review/${r._id}`}
            className="review-card"
          >
            <Card
              title={r.title}
              text={r.text}
              address={r.address}
              views={r.views}
              rating={r.rating}
              image={r.image}
              createdAt={r.createdAt}
            />
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Kebablist;
